"use strict";
ui.loadTemplateFile("register.html");

const REGISTER_ERRORS: { [code: string]: string } = {
    username: "Username must be 3-16 letters, digits or underscores.",
    password: "Password must be at least 6 characters.",
    email: "Please enter a valid email address.",
    username_taken: "That username is already taken.",
    email_taken: "That email is already registered.",
    rate_limited: "Too many registrations from your network. Try again later.",
    server: "Registration failed. Please try again later.",
};

class RegisterDialog extends Dialog {
    _element: any;
    _username: any;
    _password: any;
    _confirm: any;
    _email: any;
    _error: any;

    constructor() {
        super("register.html");

        this._username = ui.textbox(this, ".username");
        this._password = ui.textbox(this, ".password");
        this._confirm = ui.textbox(this, ".confirm");
        this._email = ui.textbox(this, ".email");
        this._error = ui.label(this, ".label.error");

        this._email.on("returnpressed", this._submit.bind(this));
        ui.button(this, ".submit").on("clicked", this._submit.bind(this));
        ui.button(this, ".cancel").on("clicked", () => {
            this.emit("cancel");
            this.close();
        });

        this.center();
    }

    _submit() {
        const username = this._username.text();
        const password = this._password.text();
        const email = this._email.text();

        if (password !== this._confirm.text()) {
            this._error.text("Passwords do not match.");
            return;
        }
        this._error.text("");

        fetch((config.infoUrl || "http://localhost:28900") + "/register", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ username, password, email }),
        })
            .then((response) =>
                response
                    .json()
                    .catch(() => ({}))
                    .then((body: any) => ({ status: response.status, body }))
            )
            .then(({ status, body }) => {
                if (status === 201) {
                    this.emit("done", username);
                    this.close();
                } else {
                    this._error.text(REGISTER_ERRORS[body.error] || REGISTER_ERRORS.server);
                }
            })
            .catch(() => this._error.text(REGISTER_ERRORS.server));
    }
}

ui.RegisterDialog = RegisterDialog;
ui.registerDialog = () => {
    return new ui.RegisterDialog();
};
